import { useState } from 'react'
import { useLucideIcon, ICON_REGISTRY } from '../primitives/lucideRegistry'
import { IconLibrary } from './IconLibrary'

/**
 * Le rendu et le déclencheur d'une icône Lucide, pour toute cellule ou tout
 * champ qui en demande une.
 *
 * Le CHOIX lui-même a quitté ce fichier : il se fait dans `IconLibrary`, la
 * pop-in plein écran qui donne accès au set complet. Ce qui reste ici, c'est le
 * bouton qui l'ouvre (`IconPicker`) et le rendu d'une icône par son nom
 * (`IconComponent`).
 */

export const IconComponent = ({ name, size = 18, ...rest }) => {
  // Registry icons render synchronously; picker options outside it lazy-load
  // from the full Lucide set on demand. Star is the fallback (and loading state).
  const Icon = useLucideIcon(name) || ICON_REGISTRY.Star
  return <Icon size={size} {...rest} />
}

/**
 * Bouton d'icône : montre celle qui est posée, ouvre la bibliothèque au clic.
 * Utilisé comme `IconCell` dans les lignes du `CollectionEditor`.
 */
export const IconPicker = ({ id, value, onChange, size = 18, buttonClass, label }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        id={id}
        type="button"
        onClick={() => setOpen(true)}
        className={buttonClass ?? 'flex items-center justify-center w-10 h-10 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 hover:border-gray-300 transition-colors'}
        aria-label={`Choisir une icône (actuellement : ${value || 'Star'})`}
        title={`Icône : ${value || 'Star'}`}
      >
        <IconComponent name={value || 'Star'} size={size} className="text-gray-600" />
      </button>

      {open && (
        <IconLibrary
          value={value}
          title={label ? `Bibliothèque d’icônes — ${label}` : undefined}
          onPick={onChange}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
